module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZmlsbD0iIzAwNjViZCIgZD0iTTAgMGg1MTJ2NTEySDB6Ii8+CiAgPHBhdGggZD0iTTAgMGw1IDNNMCAzbDUtMyIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9Ii42IiB0cmFuc2Zvcm09InNjYWxlKDEwMi40IDE3MC42NjY2NykiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/gb-sct.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/gb-sct.svg
// module chunks = 0